import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import {
  conciergeCmsLogin,
  setConciergeToken,
} from "../../../../utils/conciergeCmsAuth";
import { useConciergeUserAuth } from "./ConciergeUserAuthContext";

export default function ConciergeUserLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { reload } = useConciergeUserAuth();
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from?.pathname || "/concierge/manage/my";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    try {
      setLoading(true);
      setError("");
      const data = await conciergeCmsLogin(
        phone.replace(/\D/g, ""),
        pin.replace(/\D/g, "")
      );
      setConciergeToken(data.access_token);
      await reload();
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || "로그인에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#222] px-4 py-8">
      <div className="mx-auto flex min-h-[calc(100vh-64px)] max-w-[1700px] items-center justify-center rounded-[28px] bg-[#f7f7f8] shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
        <div className="w-full max-w-[420px] rounded-2xl border border-[#e9e9ef] bg-white p-6 shadow-[0_12px_24px_rgba(15,23,42,0.08)]">
          <h1 className="text-[18px] font-bold text-[#111827]">
            컨시어지 사용자 로그인
          </h1>

          <form className="mt-5 space-y-3" onSubmit={handleSubmit}>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder="사용자 휴대폰 번호"
              value={phone}
              onChange={(e) =>
                setPhone(e.target.value.replace(/\D/g, "").slice(0, 11))
              }
              className="h-11 w-full rounded-lg border border-[#e5e7eb] px-4 text-sm outline-none focus:border-[#7864F9]"
            />

            <div className="grid grid-cols-[1fr_88px] gap-3">
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="핀번호"
                value={pin}
                onChange={(e) =>
                  setPin(e.target.value.replace(/\D/g, "").slice(0, 6))
                }
                className="h-11 min-w-0 rounded-lg border border-[#e5e7eb] px-4 text-sm outline-none focus:border-[#7864F9]"
              />
              <button
                type="submit"
                disabled={loading}
                className="h-11 w-full rounded-lg bg-[#7864F9] px-3 text-sm font-semibold text-white disabled:opacity-60"
              >
                로그인
              </button>
            </div>
          </form>

          {error ? <div className="mt-3 text-xs text-red-500">{error}</div> : null}

          <div className="mt-4 flex items-center justify-between text-xs text-[#4b5563]">
            <Link to="/concierge/manage/find-pin" className="font-medium text-[#111827]">
              핀번호 찾기
            </Link>
            <Link to="/concierge" className="text-[#7864F9]">
              컨시어지 신청
            </Link>
          </div>

          <p className="mt-6 text-center text-[10px] text-[#6b7280]">
            Copyright © JYES Inc. All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
}
